<!--防伪查询次数-->
<template>
	<div>
		<h3>防伪查询次数</h3>
		<div>
            <div class="lines">
                <el-form ref="form" :model="form" inline :rules="rules">
                    <el-form-item prop="date" style="width: 150px;">
						<el-radio-group v-model="form.date">
                            <el-radio-button label="本月"></el-radio-button>
                            <el-radio-button label="本年"></el-radio-button>
                        </el-radio-group>
					</el-form-item>
                    <el-form-item prop="makeTime" style="width: 360px;padding-top: 1px;">
                        <el-date-picker
                        v-model="form.makeTime" clearable
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
					</el-form-item>
                    <el-button @click="restForm" style="margin-top: 1px;" type="warning">重 置</el-button>
                </el-form>
                <div>
                    <div :style="{height:'500px',width:'100%'}" ref="eChart1" id="echart1"></div>
                </div>
            </div>
            <div style="display:flex">
                <div class="table">
                    <el-button type="primary" style="margin-bottom: 15px;">导出查询次数</el-button>
                    <el-table border>
                        <el-table-column align="center" property="DataId" label="月份"></el-table-column>
                        <el-table-column align="center" property="Productcode" label="1次"></el-table-column>
                        <el-table-column align="center" property="Productname" label="2-5次"></el-table-column>
                        <el-table-column align="center" property="Productcode" label="6-10次"></el-table-column>
                        <el-table-column align="center" property="Productname" label=">10次"></el-table-column>
                    </el-table>
                </div>
                <div class="table">
                    <el-button type="primary" style="margin-bottom: 15px;">导出查询类型</el-button>
                    <el-table border>
                        <el-table-column align="center" property="DataId" label="月份"></el-table-column>
                        <el-table-column align="center" property="Productcode" label="APP二维码查询"></el-table-column>
                        <el-table-column align="center" property="Productname" label="WEB查询"></el-table-column>
                        <el-table-column align="center" property="Productcode" label="电话查询"></el-table-column>
                        <el-table-column align="center" property="Productname" label="短信查询"></el-table-column>
                    </el-table>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import echarts from "echarts";//引入图表

export default {
	data(){
		return {
            form:{
                date:'本月',
                makeTime:'',
                productForm:{
					Productcode:'',
					Productname:'',
					Norms:''
				},
            },
            rules: {
        		makeTime:[
          			{ required: true, message: '请选择时间', trigger: 'change' }
        		]
			},
            option1:{
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: 10,
                    data: ['APP二维码查询', 'WEB查询', '电话查询', '短信查询']
                },
                series: [
                    {
                        name: '查询类型',
                        type: 'pie',
                        selectedMode: 'single',
                        radius: [0, '45%'],

                        label: {
                            position: 'inner'
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            {value: 335,name: 'APP二维码查询'},
                            {value: 679,name: 'WEB查询'},
                            {value: 548,name: '电话查询'},
                            {value: 548,name: '短信查询'}
                        ]
                    },
                    {
                        name: '查询次数',
                        type: 'pie',
                        radius: ['55%', '70%'],
                        label: {
                            formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                            backgroundColor: '#eee',
                            borderColor: '#aaa',
                            borderWidth: 1,
                            borderRadius: 4,
                            // shadowBlur:3,
                            // shadowOffsetX: 2,
                            // shadowOffsetY: 2,
                            // shadowColor: '#999',
                            // padding: [0, 7],
                            rich: {
                                a: {
                                    color: '#999',
                                    lineHeight: 22,
                                    align: 'center'
                                },
                                // abg: {
                                //     backgroundColor: '#333',
                                //     width: '100%',
                                //     align: 'right',
                                //     height: 22,
                                //     borderRadius: [4, 4, 0, 0]
                                // },
                                hr: {
                                    borderColor: '#aaa',
                                    width: '100%',
                                    borderWidth: 0.5,
                                    height: 0
                                },
                                b: {
                                    fontSize: 16,
                                    lineHeight: 33
                                },
                                per: {
                                    color: '#eee',
                                    backgroundColor: '#334455',
                                    padding: [2, 4],
                                    borderRadius: 2
                                }
                            }
                        },
                        data: [
                            {value: 335, name: '1次'},
                            {value: 310, name: '2-5次'},
                            {value: 234, name: '6-10次'},
                            {value: 135, name: '>10次'},
                        ]
                    }
                ]
            }
		};
	},
	mounted : function(){
		var user = JSON.parse(sessionStorage.getItem('user'));
        this.initEcharts()
        
        var elementResizeDetectorMaker = require("element-resize-detector");//导入
        // 创建实例
        var erd = elementResizeDetectorMaker();
        // 创建实例带参
        var erdUltraFast = elementResizeDetectorMaker({
                        strategy: "scroll", //<- For ultra performance.
                        callOnAdd: true,
                        debug: true
                    });
        //监听id为test的元素 大小变化
        erd.listenTo(document.getElementById("echart1"), function(element) {
             let  myChart1 = echarts.init(document.getElementById('echart1'));
             myChart1.resize();
        });
       
        
	},
	methods: {
        //初始化
        initEcharts(){
            let  myChart1 = echarts.init(this.$refs.eChart1);
            myChart1.setOption(this.option1);
        },
        productfocus(){//获取商品
			this.productVisible=true;
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Product.ashx',
				params: {
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
				if(res.Code==0){
					this.productData=res.DataList;
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					});
				}      
			})
        },
       
        restForm(){//重置表单
			this.$nextTick(()=>{
				this.$refs['form'].resetFields()
			})
		},
	}
}
</script>

<style scoped>
.lines{
    width: 100%;
    background: #f8f8f8;
    padding: 10px;
    margin-bottom: 20px;
}
.table{
    flex:1;
    padding: 10px;
    background: #f8f8f8;
}
</style>


// WEBPACK FOOTER //
// src/pages/fwAmount.vue